/**
 * Payer-session client (spec §4) — mints an order-scoped payer identity for
 * anonymous dine-in diners (solo and POS-origin orders).
 *
 *   POST /v1/online-ordering/branches/{branchId}/tables/{tableId}/payer-session
 *   Body: {displayName, deviceFingerprint} → {payerToken, guestId, orderId}
 *
 * Auth: API key only (`skipAuth: true`; X-API-KEY auto-attaches on
 * /v1/online-ordering paths). 404 = the table has no active order — callers
 * show the friendly "ask your waiter" state. Idempotent server-side on
 * (tableId, deviceFingerprint) for the order's lifetime, so re-submitting
 * the sheet is safe.
 */

import { apiFetch } from "./http";

export interface PayerSessionInput {
  displayName: string;
  deviceFingerprint: string;
}

export interface PayerSessionResponse {
  payerToken: string;
  guestId: string;
  orderId: string;
}

export const payerSessionApi = {
  create(
    branchId: string,
    tableId: string,
    input: PayerSessionInput,
  ): Promise<PayerSessionResponse> {
    return apiFetch<PayerSessionResponse>(
      `/v1/online-ordering/branches/${encodeURIComponent(branchId)}/tables/${encodeURIComponent(tableId)}/payer-session`,
      { method: "POST", body: input, skipAuth: true },
    );
  },
};
